module.exports = __webpack_public_path__ + "static/media/08.8f44e2a0.png";